const locale = {
  VALIDATE_TITLE_TEXT: 'Verificación completada',
  VALIDATE_DESCRIPTION_TEXT: 'El código fue validado correctamente.',
  SET_TITLE_TEXT: 'Código enviado',
  SET_DESCRIPTION_TEXT: 'Revisa tu correo para ingresar el código.',
  RESEND_TITLE_TEXT: 'Código reenviado',
  RESEND_DESCRIPTION_TEXT: 'Se envió un nuevo código. Revisa tu bandeja de entrada.',
  ERROR_TITLE_TEXT: 'Error',
  ERROR_DESCRIPTION_TEXT: 'Algo salió mal. Por favor, inténtalo de nuevo.',
};

export default locale;
